import { apiFetch } from "@/api/client";

export interface DeviceSummary {
  callingstationid: string;
  vendor: string;
  usernames: string[];
  first_seen: string | null;
  last_seen: string | null;
  session_count: number;
}

export interface DeviceListResponse {
  items: DeviceSummary[];
  total: number;
  page: number;
  page_size: number;
}

export const listDevices = (search: string, page: number) =>
  apiFetch<DeviceListResponse>(
    `/devices?page=${page}&page_size=25${search ? `&search=${encodeURIComponent(search)}` : ""}`,
  );
